import { areas } from './curriculum.js'

function inc(object, key) {
  if (object[key]) {
    object[key]++;
  } else {
    object[key] = 1;
  }
}

let outcomeCounts = {};
let topicCounts = {};
const itemKinds = {};
for (const area of areas) {
  //console.log(area.id);
  for (const unit of area.units) {
    //console.log(unit.fqid);
    for (const outcome of unit.outcomes) {
      itemKinds[outcome.fqid] = 'outcome';
      inc(outcomeCounts, area.id);
      inc(outcomeCounts, unit.fqid);
    }
    for (const topic of unit.topics) {
      itemKinds[topic.fqid] = 'topic';
      inc(topicCounts, area.id);
      inc(topicCounts, unit.fqid);
      if (topic.topics) {
        for (const subtopic of topic.topics) {
          itemKinds[subtopic.fqid] = 'subtopic';
          inc(topicCounts, area.id);
          inc(topicCounts, unit.fqid);
          if (subtopic.topics) {
            for (const subsubtopic of subtopic.topics) {
              itemKinds[subsubtopic.fqid] = 'subsubtopic';
              inc(topicCounts, area.id);
              inc(topicCounts, unit.fqid);
            }
          }
        }
      }
    }
  }
}

const isItem = (fqid) => isOutcome(fqid)||isTopic(fqid);
const isOutcome = (fqid) => itemKinds[fqid]==='outcome';
const isTopic = (fqid) => isExactlyTopic(fqid)||isExactlySubtopic(fqid)||isExactlySubsubtopic(fqid);
const isExactlyTopic = (fqid) => itemKinds[fqid]==='topic';
const isExactlySubtopic = (fqid) => itemKinds[fqid]==='subtopic';
const isExactlySubsubtopic = (fqid) => itemKinds[fqid]==='subsubtopic';


export {topicCounts, outcomeCounts, isItem, isOutcome, isTopic, isExactlyTopic, isExactlySubtopic, isExactlySubsubtopic}